// import { FaBars } from "react-icons/fa";
// import logo from "../../Assets/Logos/yostelLogo.svg";
// import { useNavigate, useLocation } from "react-router-dom";
// import { IoClose } from "react-icons/io5";
// import { useState } from "react";
// import React from "react";
// import { MdLocationOn } from "react-icons/md";
// import { CgMail } from "react-icons/cg";
// import { FiPhoneCall } from "react-icons/fi";
// const BottomNavbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleSidebar = () => {
//     setIsOpen(!isOpen);
//   };

//   const getLinkClass = (path) => {
//     return location.pathname === path
//       ? "text-base font-semibold text-[#235784] cursor-pointer tracking-wide"
//       : "text-base font-semibold hover:text-[#235784] cursor-pointer tracking-wide";
//   };

//   return (
//     <div className="w-full fixed">
//       <nav className="hidden lg:flex bg-gradient-to-l from-[#00C5C8] to-[#235784]   justify-between  px-12 items-center bg-linear-[100%] text-white py-1 font-fontStyleNunito ">
//         <div className="flex justify-between gap-5 items-center">
//           <div className="flex justify-between items-center">
//             <FiPhoneCall className="xl:h-[14px] xl:w-[14px] h-[12px] w-[12px] " />
//             <h4 className="pl-1 xl:text-[12px] text-[12px] font-fontStyleDmSans">
//               +91 895 658 5458
//             </h4>
//           </div>
//           <div className="flex justify-between items-center ">
//             <CgMail className="xl:h-[25px] xl:w-[20px] h-[20px] w-[15px] " />
//             <h4 className="pl-1 xl:text-[14px] text-[14px] font-fontStyleDmSans">
//               hostel52@gmail.com
//             </h4>
//           </div>
//         </div>
//         <div>
//           <p className="xl:text-[20px] text-[18px] font-allura" id="allura">
//             "Find Your Home Away From Home"
//           </p>
//         </div>

//         <div className="flex gap-3 items-center">
//           <div className="flex justify-between items-center ">
//             <MdLocationOn className="h-[20px] w-[15px] " />
//             <h4 className="pl-1  font-fontStyleDmSans xl:text-[14px] text-[14px]">
//               H-76, Kalinga Nagar, bhubaneswar
//             </h4>
//           </div>
//         </div>
//       </nav>
//       {/* Navbar */}
//       <nav className="bg-[#fffefc] text-[#26232A] px-6 md:px-16 py-2 shadow-2xl">
//         <div className="container mx-auto flex items-center justify-between">
//           <div>
//             <img src={logo} alt="baisaly-logo" className="w-auto h-14" />
//           </div>
//           <div className="hidden md:flex space-x-8">
//             <div onClick={() => navigate("/")} className={getLinkClass("/")}>
//               Home
//             </div>
//             <div
//               onClick={() => navigate("/about")}
//               className={getLinkClass("/about")}
//             >
//               About
//             </div>
//             <div
//               onClick={() => navigate("/services")}
//               className={getLinkClass("/services")}
//             >
//               Services
//             </div>
//             {/* <div
//               onClick={() => navigate("/contact")}
//               className={getLinkClass("/contact")}
//             >
//               Contact
//             </div> */}
//           </div>
//           <div className="hidden md:block">
//             <button
//               onClick={() => navigate("/login")}
//               className="tracking-wide bg-[#235784] text-white font-bold py-2 px-6 rounded"
//             >
//               Log In
//             </button>
//           </div>
//           <div className="md:hidden">
//             <FaBars
//               onClick={toggleSidebar}
//               size={24}
//               className="cursor-pointer"
//             />
//           </div>
//         </div>
//       </nav>
//       {isOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-75 z-50">
//           <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md">
//             <div className="p-4">
//               <button
//                 className="text-black text-lg font-bold mb-8 float-right"
//                 onClick={toggleSidebar}
//               >
//                 <IoClose size={25} className="text-blue-500" />
//               </button>

//               <ul className="space-y-4 text-lg">
//                 <li
//                   onClick={() => {
//                     navigate("/");
//                     toggleSidebar();
//                   }}
//                   className={getLinkClass("/")}
//                 >
//                   Home
//                 </li>
//                 <li
//                   onClick={() => {
//                     navigate("/about");
//                     toggleSidebar();
//                   }}
//                   className={getLinkClass("/about")}
//                 >
//                   About
//                 </li>
//                 <li
//                   onClick={() => {
//                     navigate("/services");
//                     toggleSidebar();
//                   }}
//                   className={getLinkClass("/services")}
//                 >
//                   Services
//                 </li>
//                 {/* <li
//                   onClick={() => {
//                     navigate("/contact");
//                     toggleSidebar();
//                   }}
//                   className={getLinkClass("/contact")}
//                 >
//                   Contact
//                 </li> */}
//               </ul>
//               <button
//                 onClick={() => navigate("/login")}
//                 className="tracking-wide mt-8 bg-[#235784] text-white font-bold py-2 px-4 rounded"
//               >
//                 Log In
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BottomNavbar;

import { FaBars } from "react-icons/fa";
import logo from "../../Assets/Logos/yostelLogo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { useState } from "react";
import React from "react";
import { MdLocationOn } from "react-icons/md";
import { CgMail } from "react-icons/cg";
import { FiPhoneCall } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi"; // Add this import at the top

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "text-base font-semibold text-[#235784] cursor-pointer tracking-wide flex items-center"
      : "text-base font-semibold hover:text-[#235784] cursor-pointer tracking-wide flex items-center";
  };

  return (
    <div className="w-full fixed">
      <nav className="hidden lg:flex bg-gradient-to-l from-[#00C5C8] to-[#235784]   justify-between  px-12 items-center bg-linear-[100%] text-white py-1 font-fontStyleNunito ">
        <div className="flex justify-between gap-5 items-center">
          <div className="flex justify-between items-center">
            <FiPhoneCall className="xl:h-[14px] xl:w-[14px] h-[12px] w-[12px] " />
            <h4 className="pl-1 xl:text-[12px] text-[12px] font-fontStyleDmSans">
              +91 8328991641
            </h4>
          </div>
          <div className="flex justify-between items-center ">
            <CgMail className="xl:h-[25px] xl:w-[20px] h-[20px] w-[15px] " />
            <h4 className="pl-1 xl:text-[14px] text-[14px] font-fontStyleDmSans">
              hello.yostel@gmail.com
            </h4>
          </div>
        </div>
        <div className="flex gap-3 items-center">
          <div className="flex justify-between items-center ">
            <MdLocationOn className="h-[20px] w-[15px] " />
            <h4 className="pl-1  font-fontStyleDmSans xl:text-[14px] text-[14px]">
              H-76, Kalinga Nagar, bhubaneswar
            </h4>
          </div>
        </div>
      </nav>
      {/* Navbar */}
      <nav className="bg-[#fffefc] text-[#26232A] px-6 md:px-16 py-2 shadow-2xl">
        <div className="container mx-auto flex items-center justify-between">
          <div>
            <img src={logo} alt="baisaly-logo" className="w-auto h-14" />
          </div>
          <div className="hidden md:flex space-x-8">
            <div onClick={() => navigate("/")} className={getLinkClass("/")}>
              Home
            </div>
            <div
              onClick={() => navigate("/property-page")}
              className={getLinkClass("/property-page")}
            >
              Explore Accommodations
            </div>
            <div className="relative group">
              {/* Trigger + Icon */}
              {/* <div className="flex items-center gap-1 cursor-pointer">
                <div className={getLinkClass("/")}>
                  Know More
                  <FiChevronDown className="text-sm transition-transform duration-200 group-hover:rotate-180" />
                </div>
              </div> */}

              {/* Dropdown - no gap between trigger and menu */}
              {/* <div className="absolute left-0 top-full mt-1 w-48 group bg-white border rounded shadow-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition duration-200 z-50">
                <ul className="flex flex-col group">
                  <li
                    className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                    onClick={() => navigate("/about")}
                  >
                    About Us
                  </li>
                  <li
                    onClick={() => navigate("/how-it-works")}
                    className="px-4 py-2 text-black font-medium  hover:bg-gray-100 cursor-pointer text-sm"
                  >
                    How to Book?
                  </li>
                  <li
                    onClick={() => navigate("/blogs")}
                    className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                  >
                    Blogs
                  </li>
                  <li
                    onClick={() => navigate("/contact-us")}
                    className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                  >
                    Contact Us
                  </li>
                </ul>
              </div> */}
              <div className="relative group">
                {/* Trigger + Icon */}
                <div className="flex items-center gap-1 cursor-pointer">
                  <div className={getLinkClass("/")}>
                    Know More
                    <FiChevronDown className="text-sm transition-transform duration-200 group-hover:rotate-180" />
                  </div>
                </div>

                {/* Dropdown */}
                <div className="absolute left-0 top-full w-48 bg-white border rounded shadow-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-200 z-50">
                  <ul className="flex flex-col">
                    <li
                      className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                      onClick={() => navigate("/about")}
                    >
                      About Us
                    </li>
                    <li
                      onClick={() => navigate("/how-it-works")}
                      className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      How to Book?
                    </li>
                    <li
                      onClick={() => navigate("/blogs")}
                      className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      Blogs
                    </li>
                    <li
                      onClick={() => navigate("/contact-us")}
                      className="px-4 py-2 text-black font-medium hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      Contact Us
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <div
              onClick={() => navigate("/contact")}
              className={getLinkClass("/contact")}
            >
              Contact
            </div> */}
          </div>
          <div className="hidden md:block">
            <button
              onClick={() => navigate("/login")}
              className="tracking-wide bg-[#235784] text-white font-bold py-2 px-6 rounded"
            >
              Log In
            </button>
          </div>
          <div className="md:hidden">
            <FaBars
              onClick={toggleSidebar}
              size={24}
              className="cursor-pointer"
            />
          </div>
        </div>
      </nav>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50">
          <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md">
            <div className="p-4">
              <button
                className="text-black text-lg font-bold mb-8 float-right"
                onClick={toggleSidebar}
              >
                <IoClose size={25} className="text-blue-500" />
              </button>

              <ul className="space-y-4 text-lg">
                <li
                  onClick={() => {
                    navigate("/");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/")}
                >
                  Home
                </li>
                <li
                  onClick={() => {
                    navigate("/property-page");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/property-page")}
                >
                  Explore Accommodations
                </li>
                <li
                  onClick={() => {
                    navigate("/blogs");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/blogs")}
                >
                  Blog
                </li>
                {/* <li
                  onClick={() => {
                    navigate("/contact");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/contact")}
                >
                  Contact
                </li> */}
              </ul>
              <button
                onClick={() => navigate("/login")}
                className="tracking-wide mt-8 bg-[#235784] text-white font-bold py-2 px-4 rounded"
              >
                Log In
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomNavbar;
